import type { User } from "@/entities/user";

export enum ManagerStatus {
  ALIVE = "alive",
  DEAD = "dead",
  BANNED = "banned",
}

export interface Manager {
  _id: string;
  curators: string[];
  curatorsCount: number;
  status: ManagerStatus;
  teamlead: string;
  userId: User;
  createdAt: Date;
  updatedAt: Date;
}

export interface Curator {
  _id: string;
  tgUsername: string;
  tgNumber: string;
  tgId: string;
  isActive: boolean;
  isDead: boolean;
  teamlead: string;
  tgCode: string;
  createdAt: Date;
  updatedAt: Date;
  managers: Manager[];
}
